// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"e6f9f4b1","453":"7d764d69"}[chunkId] + ".chunk.js";
};